// Translation: Account > Billing > Transactions > Transfer transaction (English)
export default Object.freeze({})
